import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Button, ButtonProps } from 'vant'
import { withDefaults, CSSProperties } from 'vue'
import CommonFooterWrap from './CommonFooterWrap.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CommonFooterNextButton',
  props: {
    title: { default: '下一步' },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean },
    btnStyle: null,
    fullBtn: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any, { emit: emits }) {

const props = __props as { title: string, disabled: boolean, loading?: boolean, btnStyle?: CSSProperties, fullBtn?: boolean };




function nextHandle() {
  emits('click')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CommonFooterWrap, null, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "header"),
      _createVNode(_unref(Button), {
        class: _normalizeClass(["next-button xa-vant-button", props.fullBtn ? 'full-next-button' : '']),
        round: "",
        onClick: nextHandle,
        style: _normalizeStyle(__props.btnStyle),
        disabled: props.disabled,
        loading: props.loading
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.title), 1)
        ]),
        _: 1
      }, 8, ["class", "style", "disabled", "loading"])
    ]),
    _: 3
  }))
}
}

})